export const authors = [
    {
      id: 1,
      name: "Mahmudur Rahman",
      role: "Full Stack Developer",
      bio: "Passionate about web development and teaching others.",
      avatar: "https://res.cloudinary.com/dqovjmmlx/image/upload/f_auto,q_auto/D20250121_142959_qwuz9k",
      social: {
        twitter: "https://twitter.com/mahmud_r_farhan",
        github: "https://github.com/mahmud-r-farhan",
      },
      expertise: ["MERN Stack", "Socket", "Javascript", "React", "Node.js", "Express", "MongoDB"]
    }
  ];